<script setup lang="ts">
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

type CardVariant = 'default' | 'connected' | 'disconnected'
type CardPadding = 'sm' | 'md' | 'lg'

const props = defineProps<{
  variant?: CardVariant
  padding?: CardPadding
}>()

const cardVariants = cva('rounded-sm border bg-white shadow-[0_1px_2px_rgba(21,32,51,0.04)]', {
  variants: {
    variant: {
      default: 'border-[color:var(--color-border-soft)]',
      connected: 'border-success/20 bg-[rgba(16,185,129,0.035)]',
      disconnected: 'border-error/20 bg-[rgba(239,68,68,0.03)]',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

const paddingVariants = cva('', {
  variants: {
    padding: {
      sm: 'p-3',
      md: 'p-4 sm:p-4',
      lg: 'p-5 sm:p-6',
    },
  },
  defaultVariants: {
    padding: 'md',
  },
})
</script>

<template>
  <div :class="cn(cardVariants({ variant: props.variant }), paddingVariants({ padding: props.padding }))">
    <div v-if="$slots.header" class="mb-4">
      <slot name="header" />
    </div>
    <slot />
    <div v-if="$slots.footer" class="mt-4">
      <slot name="footer" />
    </div>
  </div>
</template>
